import { LoadingOutlined } from "@ant-design/icons";
import { Empty } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {Product, Search } from "../../components";
import { getShirt } from "../../config/Redux/action";
import { ActionProduct } from "../../config/Redux/actionTypes";

const Shirt = () => {
  const dispatch = useDispatch();
  const [shirts, setShirts] = useState([]);
  const product = useSelector((state) => state.product);
  let dataAosIcrement = 500;

  useEffect(() => {
    const getData = async () => {
      const res = await dispatch(getShirt());
      setShirts(res);
    }
    getData();
  },[dispatch])

  const totalShirt = shirts.filter((shirt) => shirt.data.publish === 'published',);

  const handleSearch = async (e) => {
    e.preventDefault();
    let data = await dispatch(getShirt());

    let searchProduct = data.filter((res) => {
      return Object.values(res.data.name)
        .join('')
        .toLowerCase()
        .includes(product.search.toLowerCase());
    });
    dispatch({ type: ActionProduct.SEARCH, value: '' });
    setShirts(searchProduct);
  };
  return (
    <div id='product-user'>
      <main>
        <section className='search'>
          <Search value={product.search} search={handleSearch} />
        </section>
        <section className='shirt'>
          <h1 data-aos='fade-right'>Produk Kaos</h1>
          {product.isLoading ? (
            <LoadingOutlined className='loadingProduct' />
          ) : (
            <div
              className={totalShirt.length > 0 ? 'product-content' : 'empty'}
            >
              {totalShirt.length > 0 ? (
                shirts
                  .filter((shirt, index) => shirt.data.publish === 'published')
                  .map((shirt, index) => {
                    return (
                      <Product
                        delay={(dataAosIcrement += 200)}
                        key={shirt.id}
                        link={`detail/${shirt.id}`}
                        image={shirt.data.image_url}
                        name={shirt.data.name}
                        normalPrice={shirt.data.price}
                        discount={shirt.data.promoPrice}
                      />
                    );
                  })
              ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              )}
            </div>
          )}
        </section>
      </main>
    </div>
  );
}

export default Shirt